import React, { useEffect, useState } from 'react';
import { CircularProgress, Box } from '@mui/material';
import { OrganizationThemeProvider } from '../contexts/OrganizationThemeContext';
import { OrganizationService } from '../services/organizationService';
import { useOrganizationPermissions } from '../hooks/useOrganizationPermissions';
import { Organization } from '../types/user';

interface OrganizationThemedRouteProps {
  children: React.ReactNode;
}

/**
 * Wrapper component that applies organization-specific theming to its children
 * Loads the user's primary organization and applies custom colors if configured
 */
export const OrganizationThemedRoute: React.FC<OrganizationThemedRouteProps> = ({ children }) => {
  const { primaryOrganization: orgFromContext } = useOrganizationPermissions();
  const [organization, setOrganization] = useState<Organization | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadOrganization = async () => {
      if (orgFromContext) {
        try {
          // Re-fetch to get latest branding data
          const org = await OrganizationService.getOrganization(orgFromContext.id);
          setOrganization(org);
        } catch (error) {          setOrganization(orgFromContext);
        }
      }
      setLoading(false);
    };

    loadOrganization();
  }, [orgFromContext?.id]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <OrganizationThemeProvider organization={organization}>
      {children}
    </OrganizationThemeProvider>
  );
};
